// DashMiniBar — CSS vertical bar chart
// Extracted from AdminIATab.tsx

import { C } from './dashboardStyles';

interface DashMiniBarProps {
  data: { label: string; value: number }[];
  maxVal?: number;
  color?: string;
  activeLabel?: string;
  onBarClick?: (label: string) => void;
}

export function DashMiniBar({
  data,
  maxVal,
  color = C.azul1,
  activeLabel,
  onBarClick,
}: DashMiniBarProps) {
  const max = maxVal || Math.max(...data.map((d) => d.value), 1);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 60 }}>
      {data.map((d, i) => {
        const isActive = activeLabel === d.label;
        const isDimmed = activeLabel && !isActive;
        return (
          <div
            key={i}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: onBarClick ? 'pointer' : 'default',
              transition: 'all 0.2s ease',
              opacity: isDimmed ? 0.3 : 1,
            }}
            onClick={() => onBarClick?.(d.label)}
          >
            <div
              style={{
                width: '100%',
                maxWidth: 28,
                borderRadius: '2px 2px 0 0',
                height: Math.max(2, (d.value / max) * 52),
                background: d.value > 0 ? color : C.grisClaro,
                borderBottom: isActive ? `2px solid ${C.azul2}` : 'none',
              }}
            />
            <span style={{ fontSize: 7, color: C.grisOscuro, marginTop: 3 }}>{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}
